import * as Sentry from '@sentry/browser'

export const AG_GRID_KEY =
  'For_Trialing_ag-Grid_Only-Not_For_Real_Development_Or_Production_Projects-Valid_Until-12_September_2021_[v2]_MTYzMTQwMTIwMDAwMA==5df1ca0151ef6b4099560ddecdafba8d'

export const TOKEN_KEY = 'ideal-auth-token'

export const PAYMENT_KEY = 'ideal-payment-overdue-date'

export const SENTRY_CONFIG = {
  dsn: 'https://44b782f3b4354441a7b329af684948cb@o392144.ingest.sentry.io/5239271',
  integrations: [Sentry.replayIntegration()]
}

export const SYNCFUSION_LICENSE_KEY =
  'ORg4AjUWIQA/Gnt2VVhjQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkxgWX5ac3FQQ2JaWEc='
